import { IErknmAnalyticsTableColumn } from 'AnalyticsPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsTableColumn';

export const initialErknmAnalyticsProsecutorOrganizationTableColumns: IErknmAnalyticsTableColumn[] = [
  {
    id: 'name',
    name: '',
  },
];
